import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserManagementRoutingModule } from './user-management-routing.module';
import { TableModule } from 'primeng/table';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateUserModalComponent } from './user-modal/create-user-modal/create-user-modal.component';
import { DialogModule } from 'primeng/dialog';
import { DialogService } from 'primeng/dynamicdialog';
import { DataTabComponent } from './user-modal/data-tab/data-tab.component';
import { AddressDataComponent } from './user-modal/address-data/address-data.component';
import { PaymentTabComponent } from './user-modal/payment-tab/payment-tab.component';
import { CommentTabComponent } from './user-modal/comment-tab/comment-tab.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { LetDirective } from '@ngrx/component';
import { InputGroupModule } from 'primeng/inputgroup';
import { ButtonModule } from 'primeng/button';
import { UserTableWrapperComponent } from './user-table-wrapper/user-table-wrapper.component';
import { SharedModule } from '../shared/shared.module';
import { MessageToUserModalComponent } from './message-to-user-modal/message-to-user-modal.component';
import { AngularMarkdownEditorModule } from 'angular-markdown-editor';
import { MarkdownModule, MARKED_OPTIONS } from 'ngx-markdown';

@NgModule({
    declarations: [
        CreateUserModalComponent,
        DataTabComponent,
        AddressDataComponent,
        PaymentTabComponent,
        CommentTabComponent,
        UserTableWrapperComponent,
        MessageToUserModalComponent
    ],
    imports: [
        CommonModule,
        UserManagementRoutingModule,
        TableModule,
        TranslateModule,
        LetDirective,
        FormsModule,
        ReactiveFormsModule,
        DialogModule,
        MultiSelectModule,
        InputTextareaModule,
        InputGroupModule,
        ButtonModule,
        SharedModule,
        AngularMarkdownEditorModule,
        MarkdownModule.forRoot({
            markedOptions: {
                provide: MARKED_OPTIONS,
                useValue: {
                    gfm: true,
                    breaks: false,
                    pedantic: false,
                    smartLists: true,
                    smartypants: false
                }
            }
        }),
        AngularMarkdownEditorModule.forRoot({
            // add any Global Options/Config you might want
            // to avoid passing the same options over and over in each component of your App
            iconlibrary: 'fa'
        })
    ],
    providers: [DialogService]
})
export class UserManagementModule {}
